<div id="page-wrapper">                 <!-- This is correct but because this component -->
    <div class="component-main">        <!-- doesn't have its own menu/ parent component-->
        <div class="content-space-between">
            <app-breadcrumbs
                routeBackName="system_overview"
                routeBackUrl="/overview"
                pageTitle="system_overview_details">
            </app-breadcrumbs>
        </div>
        <div class="content-space-between">
            <div class="content-left">
                <app-dropdown
                    dropDownId="system-details-metrics"
                    [displayAsInput]="true"
                    [selectedKey]="selectedType"
                    [content]="dropdown.types"
                    [dropdownWidth]="250"
                    (selectedOut)="updateSelectedType($event)">
                </app-dropdown>
                <app-dropdown
                    dropDownId="system-details-periods"
                    [displayAsInput]="true"
                    [selectedKey]="selectedPeriod"
                    [content]="dropdown.periods"
                    [dropdownWidth]="250"
                    (selectedOut)="updateSelectedPeriod($event)">
                </app-dropdown>
                <div class="refresh" (click)="setGraphData(true)">
                    <img
                        [class.refresh-spin]="loading"
                        ngSrc="assets/shared/icons/refresh.svg"
                        alt="refresh"
                        height="15"
                        width="15"/>
                </div>
            </div>
        </div>
        <div class="graph-wrapper">
            <h3 *ngIf="title" class="title">{{ title }} ({{ scale }})</h3>
            <canvas
                #canvas
                id="canvas"
                height="80"
                baseChart
                type="line"
                [datasets]="data.datasets"
                [options]="graphOptions">
            </canvas>
        </div>
    </div>
</div>
